import { render } from "./Gateways.vue?vue&type=template&id=56a32e0c&scoped=true"
import script from "./Gateways.vue?vue&type=script&lang=js"
export * from "./Gateways.vue?vue&type=script&lang=js"

import "./Gateways.vue?vue&type=style&index=0&id=56a32e0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a32e0c"]])

export default __exports__